import { createContext } from 'react';

export const CachedSelectContext = createContext();
